/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMarketplaceRepresentedMediaResponse } from '../../models/get-marketplace-represented-media-response';

export interface MarketplaceServiceGetMarketplaceRepresentedMedia$Params {
}

export function marketplaceServiceGetMarketplaceRepresentedMedia(http: HttpClient, rootUrl: string, params?: MarketplaceServiceGetMarketplaceRepresentedMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMarketplaceRepresentedMediaResponse>> {
  const rb = new RequestBuilder(rootUrl, marketplaceServiceGetMarketplaceRepresentedMedia.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMarketplaceRepresentedMediaResponse>;
    })
  );
}

marketplaceServiceGetMarketplaceRepresentedMedia.PATH = '/api/v3/gateway/marketplace/active_media';
